module.exports = __webpack_public_path__ + "static/p0-68437c9c99ade18b62fbce1e60ff5cea.png";